// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QvD1F","h1":"styles_h1__TJAYg"};